import { apiClient, call, callVoid } from "../../shared/api/client";

export function login(email: string, password: string) {
  return callVoid(apiClient.POST("/auth/login", { body: { email, password } }));
}

/** Batch 18 GRF-46: a passkey sign-in ceremony (anonymous, no e-mail; `allowCredentials` is empty, so it is discoverable). */
export function passkeyLoginOptions() {
  return call(apiClient.POST("/auth/passkey/options"));
}

/** 204 and the same `giraffe_session` + `XSRF-TOKEN` as `login`; every verification failure is one 401. */
export function passkeyLogin(ceremonyId: string, credential: Record<string, unknown>) {
  return callVoid(apiClient.POST("/auth/passkey/login", { body: { ceremonyId, credential } }));
}

export function logout() {
  return callVoid(apiClient.POST("/auth/logout"));
}

/** POST /auth/change-password: 204, then refetch Me; 422 validation-failed carries field errors. */
export function changePassword(body: { currentPassword: string; newPassword: string }) {
  return callVoid(apiClient.POST("/auth/change-password", { body }));
}

const ORIGIN = "http://giraffe.invalid";

/**
 * Where to go after sign-in: the exact same path and query, same-origin only (UX-01 Rev 3.2). Absolute URLs,
 * protocol-relative URLs, backslash tricks and the sign-in page itself fall back to Home.
 */
export function safeReturnPath(next: string | null): string {
  if (!next || !next.startsWith("/") || next.startsWith("//") || next.startsWith("/\\")) return "/";
  try {
    const url = new URL(next, ORIGIN);
    if (url.origin !== ORIGIN || url.pathname === "/login" || url.pathname.startsWith("/login/")) return "/";
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return "/";
  }
}

/** Where an external tester who opened an internal route goes: `/items/KEY` → that item in the portal; anything else → `/portal`. */
export function portalTarget(pathname: string): string {
  const item = /^\/items\/([A-Za-z][A-Za-z0-9]*-\d+)\/?$/.exec(pathname);
  return item ? `/portal?item=${encodeURIComponent(item[1]!)}` : "/portal";
}

